module.exports = __webpack_public_path__ + "static/media/icon-info-white.e0861138.svg";